import { EvaluationForm } from './EvaluationForm';

export type { TypeEvaluationFormProps } from './types';
export default EvaluationForm;
